import { useMutation, useQuery } from "@tanstack/react-query";
import axiosInstance from "../utils/api";
import paths from "../utils/paths";

export const useNotifications = () => {
  return useQuery({
    queryKey: ["notifications"],
    queryFn: async () => {
      const { data } = await axiosInstance.get(paths.notifications);
      return data.data;
    },
  });
};

// Update FCM token
export const useUpdateFcmToken = () => {
  return useMutation({
    mutationFn: async (fcmToken) => {
      const { data } = await axiosInstance.post(paths.updateFcmToken, { fcm_token: fcmToken.fcm_token });
      return data;
    },
  });
};

// Get notification preferences
export const useNotificationPreferences = () => {
  return useQuery({
    queryKey: ["notificationPreferences"],
    queryFn: async () => {
      const { data } = await axiosInstance.get(paths.notificationPreferences);
      console.log("notification preferences:", data);
      return data;
    },
  });
};

// Update notification preferences
export const useUpdateNotificationPreferences = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await axiosInstance.post(paths.updateNotificationPreferences, payload);
      return data;
    },
  });
};

// Mark as read notification
export const useMarkAsReadNotification = ({ onSuccess }) => {
  return useMutation({
    mutationFn: async (id) => {
      const { data } = await axiosInstance.post(paths.markAsReadNotification(id));
      return data;
    },
    onSuccess,
  });
};